// The app's line icons. Decorative
// always: every icon sits beside text or on a button with an aria-label.

const PATHS = {
  check: <path d="M5 12l5 5L20 7" />,
  chevD: <path d="M6 9l6 6 6-6" />,
  updown: <path d="M8 9l4-4 4 4M16 15l-4 4-4-4" />,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  plus: <path d="M12 5v14M5 12h14" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  pencil: <path d="M4 20h4L19 9l-4-4L4 16v4zM13.5 6.5l4 4" />,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  unlock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 7.5-2" /></>,
  trash: <><path d="M4 7h16M10 11v6M14 11v6" />
           <path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" /></>,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size }: { name: IconName; size?: number }) {
  return (
    <svg className="i" viewBox="0 0 24 24" aria-hidden="true"
         style={size ? { width: size, height: size } : undefined}>
      {PATHS[name]}
    </svg>
  );
}
